import { useEffect, useState } from "react";
import { api } from "../api/apiClient";
import { FEATURE_CODES } from "../constants/constants";
import { useAccess } from "../context/AccessContext";
import { useAuth } from "../context/AuthContext";

export default function useAiFeatureAvailability() {
  const { loading: accessLoading, hasFeature } = useAccess();
  const { selectedTenant } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const tenantHasAi = hasFeature(FEATURE_CODES.AI_INTEGRATION);
  const tenantId = selectedTenant?.tenantId;

  useEffect(() => {
    if (accessLoading || !tenantId || !tenantHasAi) {
      setEnabled(false);
      return;
    }

    let mounted = true;
    api<{ enabled: boolean }>("/api/ai/availability", {
      suppressLoading: true,
      notifyError: false,
    })
      .then((result) => {
        if (mounted) setEnabled(result.enabled);
      })
      .catch(() => {
        if (mounted) setEnabled(false);
      });

    return () => {
      mounted = false;
    };
  }, [accessLoading, tenantId, tenantHasAi]);

  return enabled;
}
